if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //load offer by hash
    if(window.location.pathname.length>1){
        setTimeout(function(){onloadReserve();},1500)
    }
    

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.top-content__slider').slick({
        pauseOnHover: false
    });
    $('.top-content__progress').addClass('active');
    $('.top-content__slider').on("beforeChange", function(event, slick, currentSlide, nextSlide){
        $('.top-content__progress').removeClass('active');
        setTimeout(function(){
            $('.top-content__progress').addClass('active');
        },50);
    });

    $('.list-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });

})();

function onloadReserve(){
    let hash = window.location.hash.replace('#','');
    if(hash.length>0 && $('.offers-search__col').length>0){
        $('.offers-search__item[data-key='+hash+']').trigger('click');
    }
}